export const ADVISORY_ROUTE_NAMES = {
  CREATE: "transitionMeetingCreate",
  EDIT: "editTransitionMeeting",
  MANAGE: "transitionMeeting",
  MY_MEETING: "myTransitionMeeting",
  MY_STUDENTS: "myStudentsTransitionMeetings",
  MY_LESSONGROUPS: "myLessongroupsTransitionMeetings",
} as const;

export type AdvisoryRouteName =
  (typeof ADVISORY_ROUTE_NAMES)[keyof typeof ADVISORY_ROUTE_NAMES];
